import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";

export const FormColorField = ({ name, control, label, rules, defaultValue="#000000", ...other }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({
        field: { onChange, value },
        fieldState: { error },
        formState,
      }) => (
        <TextField
          required={rules && rules.required}
          style={{'marginTop': 20}}
          size="small"
          onChange={onChange}
          fullWidth
          label={label}
          variant="outlined"
          value={value}
          InputProps={{
            startAdornment: <InputAdornment position="start">{value}</InputAdornment>,
          }}
          type='color'
          {...other}
        />
      )}
    />
  );
};